/**
 * Labeled text input or textarea with dark-theme styling (glass surface, sky focus).
 */
const controlSurface =
  "mt-1 w-full rounded-xl border border-white/10 bg-white/[0.04] px-4 py-2.5 text-sm text-white shadow-sm backdrop-blur-sm transition-all duration-200 " +
  "placeholder:text-white/40 hover:border-white/20 " +
  "focus:border-sky-400/55 focus:outline-none focus:ring-2 focus:ring-sky-400/50 focus:ring-offset-2 focus:ring-offset-black/40 " +
  "disabled:cursor-not-allowed disabled:opacity-50 read-only:opacity-80 [color-scheme:dark]";

export default function TextField({
  id,
  label,
  type = "text",
  value,
  onChange,
  placeholder,
  readOnly = false,
  required = false,
  disabled = false,
  multiline = false,
  rows = 4,
  maxLength,
  helperText,
  hideLabel = false,
  className = "",
}) {
  const inputId = id || (label ? label.toLowerCase().replace(/\s+/g, "-") : "field");

  const fieldClass = `${multiline ? `${controlSurface} min-h-[8rem] resize-y py-3` : `${controlSurface} min-h-[2.75rem]`} ${hideLabel ? "!mt-0" : ""}`.trim();

  return (
    <div className={className}>
      {!hideLabel ? (
        <label htmlFor={inputId} className="block text-sm font-medium text-white/90">
          {label}
          {required ? <span className="text-rose-300"> *</span> : null}
        </label>
      ) : null}
      {multiline ? (
        <textarea
          id={inputId}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          readOnly={readOnly}
          disabled={disabled}
          required={required}
          rows={rows}
          maxLength={maxLength}
          className={fieldClass}
          aria-label={hideLabel ? label : undefined}
        />
      ) : (
        <input
          id={inputId}
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          readOnly={readOnly}
          disabled={disabled}
          required={required}
          maxLength={maxLength}
          className={fieldClass}
          aria-label={hideLabel ? label : undefined}
        />
      )}
      {helperText ? <p className="mt-1 text-xs text-white/55">{helperText}</p> : null}
    </div>
  );
}
